<div
  [mat-menu-trigger-for]="years_menu"
  class="hmn-unit-details-header-controls-year hmn-padding__x2-horiz hmn-row__align hmn-cursor__pointer">
  <p class="hmn-color__accent hmn-margin__x2-left">{{ current_year }}</p>

  <mat-icon class="hmn-color__accent hmn-margin__x4-left"> arrow_drop_down </mat-icon>
</div>

<mat-menu
  #years_menu="matMenu"
  yPosition="below"
  class="hmn-menu__year">
  <span
    (click)="onYearClick(year)"
    mat-menu-item
    *ngFor="let year of years">
    {{ year }}
  </span>
</mat-menu>
